import { render, staticRenderFns } from "./consultation_editor.vue?vue&type=template&id=2e1629df"
import script from "./consultation_editor.vue?vue&type=script&lang=js"
export * from "./consultation_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports